import React, { Dispatch, SetStateAction } from 'react'
import { Body, Title, Details, ImageContainer } from './styles'
import { PortalModal } from '~/components/shared/PortalModal'
import { Images } from '~/assets/images'

const HIDE = false

const BabyImage = (): JSX.Element => {
  const Image = Images.babyNotFound

  return <ImageContainer>{Image && <Image />}</ImageContainer>
}

interface IBabyNotFoundMessageProps {
  show: boolean
  onClose: Dispatch<SetStateAction<boolean>>
}

export const BabyNotFoundMessage = ({ show, onClose }: IBabyNotFoundMessageProps): JSX.Element => {
  const handleOnClose = () => {
    onClose(HIDE)
  }

  return (
    <PortalModal show={show} onClose={handleOnClose} size="small">
      <Body>
        <BabyImage />
        <Title>Bebê não encontrado</Title>
        <Details>Não foi encontrado nenhum bebê associado a esta gestação na base de dados</Details>
      </Body>
    </PortalModal>
  )
}
